module.exports = __webpack_public_path__ + "static/media/plus.bbf59456.svg";